import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import styles from './styles.module.css';
import clsx from 'clsx';

export function CameraSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.camera')}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      className={clsx(styles.brand, className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0016 22.4001C39.0708 22.4001 44.8016 28.1309 44.8016 35.2001C44.8016 42.2693 39.0708 48.0001 32.0016 48.0001C24.9323 48.0001 19.2016 42.2693 19.2016 35.2001C19.2016 28.1309 24.9323 22.4001 32.0016 22.4001ZM32.0016 26.4001C27.1415 26.4001 23.2016 30.34 23.2016 35.2001C23.2016 40.0602 27.1415 44.0001 32.0016 44.0001C36.8617 44.0001 40.8016 40.0602 40.8016 35.2001C40.8016 30.34 36.8617 26.4001 32.0016 26.4001Z"
        fill="inherit"
      />
      <path
        d="M50.7906 21.6001C52.5579 21.6001 53.9906 23.0328 53.9906 24.8001C53.9906 26.5674 52.5579 28.0001 50.7906 28.0001C49.0233 28.0001 47.5906 26.5674 47.5906 24.8001C47.5906 23.0328 49.0233 21.6001 50.7906 21.6001Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.4016 56.8001H1.60156V13.6001H17.6016V5.6001H46.4016V13.6001H62.4016V56.8001ZM21.6016 17.6001H5.60156V52.8001H58.4016V17.6001H42.4016V9.6001H21.6016V17.6001Z"
        fill="inherit"
      />
    </svg>
  );
}
